import { useT } from "../lib/i18n/store.js";
import { siteInfo } from "../lib/siteInfo.js";
import type { AccountBlockReason } from "../apiClient.js";

/**
 * Full-screen notice for a signed-in account the API refuses outright: suspended
 * (open access) or not on the closed-beta list. One short reason, the account in
 * its own row, how to reach support (suspension only), and a way to sign out.
 */
export function AccountBlockedScreen({
  reason,
  email,
  onSignOut
}: {
  reason: AccountBlockReason;
  email: string;
  onSignOut: () => void;
}) {
  const t = useT();
  const suspended = reason === "account_suspended";
  const support = siteInfo.supportEmail;
  const supportIsEmail = support.includes("@") && !support.startsWith("[");

  return (
    <section className="auth-page">
      <div className="auth-card account-blocked">
        <span className="account-blocked-icon" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
            <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
          </svg>
        </span>
        <h1>{suspended ? t("beta.suspendedTitle") : t("beta.notInTitle")}</h1>
        <p className="account-blocked-lead">{suspended ? t("beta.suspendedBody") : t("beta.notInBody")}</p>

        <div className="account-blocked-row">
          <span className="account-blocked-label">{t("beta.signedInAs")}</span>
          <span className="account-blocked-value">{email}</span>
        </div>

        {suspended && (
          <div className="account-blocked-row">
            <span className="account-blocked-label">{t("beta.contactSupport")}</span>
            {supportIsEmail ? (
              <a className="account-blocked-value" href={`mailto:${support}`}>
                {support}
              </a>
            ) : (
              <span className="account-blocked-value">{support}</span>
            )}
          </div>
        )}

        <button type="button" className="primary-button account-blocked-signout" onClick={onSignOut}>
          {t("beta.signOut")}
        </button>
      </div>
    </section>
  );
}
